import useFetch from '../hooks/useFetch'
import { apiWrapper, apiDownloadWrapper } from './dataHookUtils'

export default () => {
  const fetch = useFetch()


  const fetchFeedback = async (eventId) => {
    return apiWrapper({
      fetch,
      url: `events/event/feedback?eventId=${eventId}`,
      options: {
        method: 'GET'
      }
    });
  }

  const downloadFeedback = async (eventId) => {
    return apiDownloadWrapper({
      fetch,
      url: `events/event/feedback/download?eventId=${eventId}`,
      options: {
        method: 'GET'
      }
    });
  }

  return {
    fetchFeedback,
    downloadFeedback
  }
}